import { combineReducers } from 'redux';
// import { connectRouter } from 'connected-react-router';
import { reducer as toastrReducer } from 'react-redux-toastr';

import authReducer from '../../modules/auth/store/reducer';
import usersReducer from '../../modules/users/store/reducer';
import permissionsReducer from '../../modules/permissions/store/reducer';
import partnersReducers from '../../modules/partners/store/reducer';
import vehiclesReducer from '../../modules/vehicles/store/reducer';
import vehiclesConfirmationReducer from '../../modules/vehicle-confirmation/store/reducer';
import insurancesReducer from '../../modules/insurances/store/reducer';
import clientsReducer from '../../modules/clients/store/reducer';
import ordersReducer from '../../modules/orders/store/reducer';
import reportsReducer from '../../modules/reports/store/reducer';
import carmenReducer from '../../modules/carmen/store/reducer';
import statusesReducer from '../../modules/statuses/store/reducer';
import contractsFeesReducer from '../../modules/partners/contracts/store/reducer';

import dashboardReducer from '../../modules/dashboard/store/reducer';

import vzrReducers from '../../modules/vzr/reducers';
import notificationsReducer from '../../modules/notifications/push/reducer';

const rootReducer = () => combineReducers({
  // router: connectRouter(history),
  toastr: toastrReducer,
  auth: authReducer,
  users: usersReducer,
  permissions: permissionsReducer,
  partners: partnersReducers.partners,
  // partners-модуль: все подслайсы (contacts/legals/fias/divisions/offices/
  // corporateExecutors) — на MobX, остался только базовый partnersReducer
  // (список/карточка партнёров, страховые привязки, лого)
  vehicles: vehiclesReducer, // Reducer для управления гаражом клиента + получение модификаций, комплектаций
  insurances: insurancesReducer, // Reducer для страховых компаний
  clients: clientsReducer,
  orders: ordersReducer,
  dashboard: dashboardReducer,
  vzr: vzrReducers,
  vehiclesConfirmation: vehiclesConfirmationReducer,
  reports: reportsReducer, // Reducer для разных отчётов
  notifications: notificationsReducer,
  carmen: carmenReducer,
  statuses: statusesReducer,
  contractsFees: contractsFeesReducer, // Reducer для управления договорами и комиссиями по договорам партнёра.
});

export default rootReducer;
